import { render, staticRenderFns } from "./OrgManager.vue?vue&type=template&id=7973448b&scoped=true"
import script from "./OrgManager.vue?vue&type=script&lang=js"
export * from "./OrgManager.vue?vue&type=script&lang=js"
import style0 from "./OrgManager.vue?vue&type=style&index=0&id=7973448b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973448b",
  null
  
)

export default component.exports